import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import vuexCache from 'vuex-cache';
import pathify from './pathify';
import selects from '@/modules/selects/_store';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

Vue.use(Vuex);

export default new Store({
    plugins: [
        vuexCache({ timeout: 60000 }),
        pathify.plugin,
    ],
    modules: { selects },
    strict: true,
    state,
    getters,
    mutations,
    actions,
});
